// extracted by mini-css-extract-plugin
export default {"flex":"toggle_flex__gYwxe","label":"toggle_label__v8W9C","wrapper":"toggle_wrapper__TT84K","active":"toggle_active__f3yDU"};